import React, { Component } from 'react';
import selos2 from '../images/selos2.png';
import NumberFormat from 'react-number-format';
import axios from 'axios';
import Swal from 'sweetalert2';
import { Redirect  } from 'react-router-dom';




class confirmationCard extends Component {
    constructor(props){
        super(props);
        this.state = {
            tokenCard: '',
            tokensms: '',
            opacity1: '',
            showSMS: props.showSMS ?? false,
            timeToRedirect: false,
            number: props.number,
            token: props.token
        }
        console.log({ props })
        if(props.showSMS) this.sendSMS();
    }
    returnTo = () => {
        this.props.changeConfirmation("init",false);
    }

    cardValidate = (event) => {
        
        if(this.state.tokenCard == "") {
            Swal.fire(
                'Erro',
                "Preencha o campo!",
                'error'
            )
            return;
        }

        event.preventDefault();
        this.setState({opacity1: true}); 

        axios.post(`https://www.pagtel.com.br/AlgarCasca360/v1/cardValidate`, {
            transactionId: new Date().getTime(),
            msisdn: "55"+this.props.number,
            token: this.state.tokenCard
        }, { headers: {"Authorization": "Bearer " + this.props.token } })
        .then(res => {
            if(res.data.code == "P00"){
                if(res.data.isValid == "True") {   
                    this.setState({timeToRedirect: true});
                }
                else {
                    Swal.fire(
                        'Código Errado',
                        "digite novamente!",
                        'error'
                    )
                    this.setState({opacity1: false}); 

                }
            }
            else {
                Swal.fire(
                    'Erro!',
                    res.data.msg,
                    'error'
                )
                this.setState({opacity1: false}); 
            }

        })
        .catch(res => {
            Swal.fire(
                'Erro!',
                "Não foi possível conectar com o servidor!",
                'error'
            )
            this.setState({opacity1: false}); 
        })
    }

    sendSMS = () => {
        const { number, token } = this.state ?? this.props;

        axios.post(`https://www.pagtel.com.br/AlgarCasca360/v2/sendSMS`, {
            transactionId: new Date().getTime(),
            msisdn: "55"+ number,
            text: "Seu Token de Acesso ao site é:",
            tokenValidate: true
        }, { headers: {"Authorization": "Bearer " + token } })
        .then(res => {
            if(res.data.code == "P00"){
                Swal.fire(
                    'Token enviado!',
                    "Verifique sua caixa de SMS!",
                    'success'
                )
            }
            else {
                Swal.fire(
                    'Erro!',
                    res.data.msg,
                    'error'
                )
            }

        })
        .catch(res => {
            Swal.fire(
                'Erro!',
                "Não foi possível conectar com o servidor!",
                'error'
            )
        })
    }

    smsValidate = (event) => {
        event.preventDefault();
        console.log('sms');
        axios.post(`https://www.pagtel.com.br/AlgarCasca360/v2/ValidateSMSToken`, {
            transactionId: new Date().getTime(),
            msisdn: "55"+this.props.number,
            value: this.state.tokensms
        }, { headers: {"Authorization": "Bearer " + this.props.token } })
        .then(res => {
            if(res.data.code == "P00"){
                this.setState({timeToRedirect: true}); 
            }
            else {
                Swal.fire(
                    'Erro!',
                    res.data.msg,
                    'error'
                )
            }

        })
        .catch(res => {
            Swal.fire(
                'Erro!',
                "Não foi possível conectar com o servidor!",
                'error'
            )
        })
    }

    btnReceberCodigo = () => {
        this.setState({showSMS: true}); 
        this.sendSMS();
    }

    render() {
        if(this.state.timeToRedirect){
            return <Redirect 
                to={{
                    pathname: "/Recarga",
                    state:{
                        numberFormat: this.props.numberFormat,
                        number: "55"+this.props.number,
                        token: this.props.token
                    }
                }}                        
            />
        }

        const digit = this.props.number.toString()[2];

        const opacity1 = this.state.opacity1 ? 'opacity' : '';
        const showSMS = this.state.showSMS ? 'showSMS' : '';
        const showBoxSMS = (parseInt(digit) < 6) ? 'showBoxSMS' : '';

        return (
            <div className="content-left confirmCard">
                <div className={`confirCard ${showSMS}`}>
                    <h2>CONFIRMAÇÃO TITULARIDADE</h2>
                    <p>PARA CONTINUAR INFORME OS ÚLTIMOS 4 DIGITOS</p>
                    <p>DE QUALQUER CARTÃO DE CRÉDITO UTILIZADO NA RECARGA</p>
                    <form onSubmit={this.cardValidate}>
                        <div className="content-left--input">
                            <div className="content-left--input-cell">

                                <NumberFormat className="number" placeholder="Digite os 4 últimos digitos do cartão" 
                                    onValueChange={(values) => {
                                        const {value} = values;
                                        this.setState({tokenCard: value})
                                    }} 
                                    value={this.state.tokenCard} format="####" />
                                <i className="icon-cel"></i>
                            </div>
                            <div onClick={this.cardValidate} className={`content-left--input-btn ${opacity1}`}>
                                RECARREGAR
                            </div>
                        </div>
                    </form>
                    <p className="second-p">APROVEITE ESTA FACILIDADE E RECARREGUE
                    TAMBÉM O CELULAR DE PARENTES E AMIGOS!</p>
                    <div onClick={this.btnReceberCodigo} className={`content-left--input-btn-confirmCard ${showBoxSMS}`}>
                        RECEBER CÓDIGO ACESSO
                    </div>
                    <div onClick={this.returnTo} className="content-left--input-btn-change-celular">
                        ALTERAR CELULAR
                    </div>
                    <div className="content-left-selos">
                        <img src={selos2} alt="selos"/>
                    </div>   
                </div>   
                <div className={`sms ${showSMS}`}>
                    <h2>CONSULTE SUAS <br/>
                        MENSAGENS</h2>
                    <p>SEU CÓDIGO DE ACESSO FOI ENVIADO VIA SMS:</p>
                    <form onSubmit={this.smsValidate}>
                        <div className="content-left--input">
                            <div className="content-left--input-cell">

                                <NumberFormat className="number" placeholder="Digite o código de acesso" 
                                    onValueChange={(values) => {
                                        const {value} = values;
                                        this.setState({tokensms: value})
                                    }} 
                                    value={this.state.tokensms} format="####" />
                                <i className="icon-cel"></i>
                            </div>
                            <div onClick={this.smsValidate} className={`content-left--input-btn ${opacity1}`}>
                                VALIDAR
                            </div>
                        </div>
                    </form>
                    <p className="second-p">CASO QUEIRA, VOCÊ TAMBÉM PODE DIGITAR O CÓDIGO DE ACESSO RECEBIDO EM SEU CELULAR.</p>
                    <div onClick={this.returnTo} className="content-left--input-btn-change-celular">
                        ALTERAR CELULAR
                    </div>
                    <p className="third-p">Se preferir, ligue *0012 e ouça seu código!</p>
                    <div onClick={this.sendSMS} className="content-left--input-btn-confirmCard">
                        NÃO RECEBI O CÓDIGO
                    </div>
                    
                    <div className="content-left-selos">
                        <img src={selos2} alt="selos"/>
                    </div>  
                </div>
            </div>
        )
    }
}

export default confirmationCard; // Don’t forget to use export default!